export default function mesAtual() {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Adiciona 1, pois os meses são baseados em zero (janeiro = 0)
  return currentMonth;
}
